export const LANGUAGE_CODE = 'ja-JP';
export const MARKET_CODE = 'JPN';
export const CURRENCY_CODE = 'JPY';
export const DOMESTIC_DOMAIN_URL = 'https://travel.rakuten.co.jp';
export const DEFAULT_HOST = 'travel.rakuten.co.jp';
export const DEFAULT_REVIEW_HOST = 'https://review.travel.rakuten.co.jp';
export const REVIEW_HOSTNAME = 'review.travel.rakuten.co.jp';
export const HOTEL_DOMAIN_URL = 'https://hotel.travel.rakuten.co.jp';
export const NO_SCORE_PLACEHOLDER = '-';
export const PC_VIEW_COUNT_THRESHOLD = 0.25;
export const SP_VIEW_COUNT_THRESHOLD = 0.15;
export const LIKE_DEBOUNCE_DELAY = 1000;
export const VIEW_COUNT_DEBOUNCE_DELAY = 30000;
export const VIEW_COUNT_ID_LIMIT = 1000;
export const PAGE_INDICATOR = 'page';
export const REVIEW_LIST_LOAD_MORE_LIMIT = 20;
export const INTERNAL_SERVER_ERROR = 500;
export const MY_REVIEW_Q_AND_A_URL = 'https://img.travel.rakuten.co.jp/image/tr/hs/product/JHGDX/';
export const POST_SUCCESS_Q_AND_A_URL = 'https://img.travel.rakuten.co.jp/image/tr/hs/product/0TuJG/';
